// import axios from 'axios'
// import Swal from 'sweetalert2'
// let config = null;
// let baseUrl = '';
// export let imgBaseUrl = '';
// export let configMessage = '';

// /**
//  * Load `config.json` dynamically.
//  */
// export const loadConfig = async () => {
//     if (!config) {
//         try {
//             const response = await fetch('/config.json');
//             if (!response.ok) {
//                 throw new Error('Failed to load config.json');
//             }
//             config = await response.json();
//         } catch (error) {
//             console.error('Error loading config.json:', error);
//             throw error;
//         }
//     }
//     return config;
// };

// /**
//  * Initialize URLs from the loaded `config.json`.
//  */
// export const initializeUrls = async () => {
//     const cfg = await loadConfig();
//     baseUrl = cfg.baseUrl;
//     imgBaseUrl = cfg.imgBaseUrl;
//     configMessage = cfg.message;
// };


// await initializeUrls();
// const header = { 'Content-Type': 'application/json; charset=utf-8' }
// const getAuthHeader = () => {
//     try {
//         let token = localStorage.getItem('token');
//         if (token) {
//             token = token.replace(/"/g, '');
//            return { 'Authorization': 'Bearer ' + token };
//         }
//         else{
//             // window.location.replace('login')
//         }
        
//     } catch (error) {

//     }
// }
// const api = async (method, url, params = {}, additionalHeaders = null) => {
//     // additionalHeaders:{ preventShowError : boolean };

//     let myHeaders = new Headers();
//     myHeaders.append("Content-Type", "application/json; charset=utf-8");
//     // myHeaders.append("Cookie", "JSESSIONID=node072dec6r1f87vg7gwqo6l9urd298.node0");

//     if (method == "get") {
//         // url += "?";
//         // var paramsObj = Object.keys(params).map((key) => [(key), params[key]]);
//         // paramsObj.forEach((element, index) => {
//         //     url += `${index}=!${element}&`;
//         // });
//         // let raw = JSON.stringify(params);
//         // let requestOptions = {
//         //     method: 'GET',
//         //     headers: myHeaders,
//         //     body: raw,
//         //     redirect: 'follow'
//         // };
//         // return await fetch(`${baseUrl}${url}`, requestOptions);

//         var data = JSON.stringify(params);

//         var config = {
//             method: 'get',
//             maxBodyLength: Infinity,
//             url: `${baseUrl}${url}`,
//             withCredentials: false,
//             headers: {
//                 'Content-Type': 'application/json; charset=utf-8',
//                 //   'Content-Type': 'application/x-www-form-urlencoded'
//             },
//             data: data
//         };
//         axios.defaults.withCredentials = true;
//         return new Promise(async (resolve, reject) => {

//             let result = null;
//             let response = await axios(config).then(res => {
//                 result = res;
//             }).catch(error => {
//                 if (error && error.response && error.response.status == 401) {
//                     // window.location.replace('/pages/login');
//                 }
//                 else {
//                     result = error.response;
//                     if (!additionalHeaders || additionalHeaders.preventShowError !== true) {
//                         // store.dispatch({ type: "SET_ERRORS", payload: { errors: [error.response.data] } });
//                     }
//                 }
//                 reject(error);
//             })
//             resolve(result);
//         });
//     }
//     if (method == "post") {
//         // let raw = JSON.stringify(params);
//         // let requestOptions = {
//         //     method: 'POST',
//         //     headers: myHeaders,
//         //     body: raw,
//         //     redirect: 'follow'
//         // };        
//         // return await fetch(`${baseUrl}${url}`, requestOptions);

//         var data = JSON.stringify(params);

//         var config = {
//             method: 'post',
//             maxBodyLength: Infinity,
//             url: `${baseUrl}${url}`,
//             withCredentials: false,
//             headers: {
//                 'Content-Type': 'application/json; charset=utf-8',
//                 //   'Content-Type': 'application/x-www-form-urlencoded'
//             },
//             data: data
//         };
//         axios.defaults.withCredentials = true;
//         return new Promise(async (resolve, reject) => {

//             let result = null;
//             let response = await axios(config).then(res => {
//                 result = res;
//             }).catch(error => {
//                     // Swal.fire({
//                     //     icon: "warning",
//                     //     title: "لطفا دوبار تلاش نمایید",
//                     //     showConfirmButton: false,
//                     //     timer: 1500
//                     // })
               
//                 reject(error);
//             })
//             resolve(result);
//         });
//     }
//     // if you need to pass some params in url (post method) use 
//     // method = "postQuery" and your params should be like this : 
//     // params = {query : { ... : ...} , raw : { ... : ...}}
//     if (method == "postQuery") {
//         url += "?";
//         var paramsObj = Object.keys(params.query).map((key) => [(key), params.query[key]]);
//         paramsObj.forEach((element, index) => {
//             url += `${element[0]}=${element[1]}&`;
//         });
//         // return await axios.post(url, params.raw, { headers: { ...defaultHeaders() } });
//         let raw = JSON.stringify(params);
//         let requestOptions = {
//             method: 'POST',
//             headers: myHeaders,
//             body: raw,
//             redirect: 'follow'
//         };
//         return await fetch(`${baseUrl}${url}`, requestOptions);
//     }
// };

// // services


// // Orders
// // export const GetGiftCardOrders = async (params) => {
// //     return api("post", `/Order/GetGiftCardOrders`, params);
// // }
// // export const GetGiftCardSerials = async (params) => {
// //     return api("get", `/Order/GetGiftCardSerials/${params}`);
// // }

// //user,login,register
// export const IsMobileExsits = async (params) => {
//     return api("post", `/User/IsMobileExsits`, params);
// }
// export const sendOtp = async (params) => {
//     return api("post", `/User/SendOtp`, params);
// }
// export const loginByPass = async (params) => {
//     return api("post", `/User/LoginByPass`, params);
// }
// export const loginByOtp = async (params) => {
//     return api("post", `/User/LoginByOtp`, params);
// }
// export const RegisterByOtp = async (params) => {
//     return api("post", `/Register/Fast`, params);
// }

// export const getUserInfo = async () => {
//         return await axios.get(baseUrl + `/User`, {
//             headers:
//             getAuthHeader(), withCredentials: false
//         }  )
// };
// export const getEditUser = async (params) => {
//     return await axios.post(baseUrl + `/User/Edit`,params, {
//         headers:
//         getAuthHeader(), withCredentials: false
//     }  )
// };
// export const getUserCard = async (params) => {
//     return await axios.post(baseUrl + `/Card/UserCards`,params, {
//         headers:
//         getAuthHeader(), withCredentials: false
//     }  )
// };
// export const getUserCharges = async (params) => {
//     return await axios.post(baseUrl + `/Card/UserCharges`,params, {
//         headers:
//         getAuthHeader(), withCredentials: false
//     }  )
// };
// export const getCharge = async (params) => {
//     return await axios.post(baseUrl + `/Card/Charge`,params, {
//         headers:
//         getAuthHeader(), withCredentials: false
//     }  )
// };
// export const getInventory = async (params) => {
//     return await axios.post(baseUrl + `/Card/Inventory`,params, {
//         headers:
//         getAuthHeader(), withCredentials: false
//     }  )
// };
// export const sendRegisterOtp = async (params) => {
//     return api("post", `/Register/SendOtp`, params);
// }
// export const registerCheckOtp = async (params) => {
//     return api("post", `/Register/CheckOtp`, params);
// }
// export const register = async (params) => {
//     return api("post", `/Register`, params);
// }


// //change-password

// export const sendOtpChangePassword = async (params) => {
//     return api("post", `/ChangePassword/SendOtp`, params);
// }
// export const checkOtpChangePassword = async (params) => {
//     return api("post", `/ChangePassword/CheckOtp`, params);
// }
// export const ChangePassword = async (params) => {
//     return api("post", `/ChangePassword`, params);
// }

// //category
// export const getCategories = async (params) => {
//     return api("get", `/Category/GetList`, params);
// }

// //product
// export const getProductsBySearch = async (params) => {
//     return api("post", `/Product/Search`, params);
// }
// export const getProductsById= async (params) => {
//     return api("get", `/Product/${params}`);
// }
// export const getTermsConditions = async (params) => {
//     return api("get", `/Pages/TermsConditions`, params);
// }

// export const getAboutUs = async (params) => {
//     return api("get", `/Pages/AboutUs`, params);
// }

// export const getProvince = async () => {
//     return api("get", `/Setting/Provinces`);
// }

// export const getCity = async (params) => {
//     return api("post", `/Setting/Cities`, params);
// }

// export const getSettings = async (params) => {
//     return api("get", `/Setting/Get`, params);
// }


// export const getMyCard = async () => {
//     return await axios.get(baseUrl + `/Card/UserCards`, {
//         headers:
//         getAuthHeader(), withCredentials: false
//     })
// };


// export const buyCard = async (params) => {
//     return await axios.post(baseUrl + `/Card/buy`,params,{
//         headers:
//         getAuthHeader(), withCredentials: false
//     } )
// };

// export const fastCharge = async (params) => {
//     return await axios.post(baseUrl + `/Card/FastCharge`,params,{
//         withCredentials: false
//     } )
// };

// export const BuyConfirm = async (params) => {
//     return await axios.post(baseUrl + `/Card/BuyConfirm`,params,{
//         headers:
//         getAuthHeader(), withCredentials: false
//     } )
// };

// export const UpdateCard = async (params) => {
//     return await axios.post(baseUrl + `/Card/Update`,params,{
//         headers:
//         getAuthHeader(), withCredentials: false
//     } )
// };



// export const addToBasket = async (params) => {
//     return await axios.post(baseUrl + `/Basket`,params,{
//         headers:
//         getAuthHeader(), withCredentials: false
//     } )
// };

// export const deleteFromBasket = async (params) => {
//     return await axios.post(baseUrl + `/Basket/Delete`,params,{
//         headers:
//         getAuthHeader(), withCredentials: false
//     } )
// };

// export const setCountBasketList = async (params) => {
//     return await axios.post(baseUrl + `/Basket/SetCount`,params,{
//         headers:
//         getAuthHeader(), withCredentials: false
//     } )
// };


// export const getBasketList = async (params) => {
//     return await axios.get(baseUrl + `/Basket/${params}`, {
//         headers:
//         getAuthHeader(), withCredentials: false
//     })
// };
import axios from 'axios';
import Swal from 'sweetalert2';

let config = null;
let baseUrl = '';
export let imgBaseUrl = '';
export let configMessage = '';

/**
 * Load `config.json` dynamically.
 */
export const loadConfig = async () => {
  if (!config) {
    try {
      const response = await fetch('/config.json');
      if (!response.ok) {
        throw new Error('Failed to load config.json');
      }
      config = await response.json();
    } catch (error) {
      console.error('Error loading config.json:', error);
      throw error;
    }
  }
  return config;
};

/**
 * Initialize URLs from the loaded `config.json`.
 */
export const initializeUrls = async () => {
  const cfg = await loadConfig();
  baseUrl = cfg.baseUrl;
  imgBaseUrl = cfg.imgBaseUrl;
  configMessage = cfg.message;

  axios.defaults.baseURL = baseUrl;
  axios.defaults.withCredentials = false;
};

await initializeUrls();

// Create Axios Instance
const apiInstance = axios.create({
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
  },
});

// Request Interceptor
apiInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')?.replace(/"/g, '');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor
apiInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
        localStorage.removeItem('userData')
        sessionStorage.removeItem('cartItems')
        localStorage.removeItem('token')
        window.location.href = '/login'
    } else {
      Swal.fire({
        icon: 'error',
        title: 'خطایی رخ داده است',
        text: error.response?.data?.message || 'لطفا مجدد تلاش کنید',
      });
      console.log(error)
    }
    return Promise.reject(error);
  }
);

// Helper API Call
const api = async (method, url, params = {}) => {
  if (method === 'get') {
    return await apiInstance.get(url, { params });
  }
  if (method === 'post') {
    return await apiInstance.post(url, params);
  }
  if (method === 'postQuery') {
    const queryParams = new URLSearchParams(params.query).toString();
    return await apiInstance.post(`${url}?${queryParams}`, params.raw);
  }
  if(method === 'test')
    {
        return await apiInstance.post('https://httpbin.org/status/401');
  }
};

// User APIs
export const IsMobileExsits = (params) => api('post', `/User/IsMobileExsits`, params);
export const sendOtp = (params) => api('post', `/User/SendOtp`, params);
export const loginByPass = (params) => api('post', `/User/LoginByPass`, params);
export const loginByOtp = (params) => api('post', `/User/LoginByOtp`, params);
export const RegisterByOtp = (params) => api('post', `/Register/Fast`, params);
export const sendRegisterOtp = (params) => api('post', `/Register/SendOtp`, params);
export const registerCheckOtp = (params) => api('post', `/Register/CheckOtp`, params);
export const register = (params) => api('post', `/Register`, params);
export const getUserInfo = () => api('get', `/User`);
export const getEditUser = (params) => api('post', `/User/Edit`, params);
export const getUserCard = (params) => api('post', `/Card/UserCards`, params);
export const getUserCharges = (params) => api('post', `/Card/UserCharges`, params);
export const getCharge = (params) => api('post', `/Card/Charge`, params);
export const getInventory = (params) => api('post', `/Card/Inventory`, params);

// Change Password
export const sendOtpChangePassword = (params) => api('post', `/ChangePassword/SendOtp`, params);
export const checkOtpChangePassword = (params) => api('post', `/ChangePassword/CheckOtp`, params);
export const ChangePassword = (params) => api('post', `/ChangePassword`, params);

// Category & Product
export const getCategories = (params) => api('get', `/Category/GetList`, params);
export const getProductsBySearch = (params) => api('post', `/Product/Search`, params);
export const getProductsById = (id) => api('get', `/Product/${id}`);
export const getTermsConditions = (params) => api('get', `/Pages/TermsConditions`, params);
export const getAboutUs = (params) => api('get', `/Pages/AboutUs`, params);

// Settings
export const getProvince = () => api('get', `/Setting/Provinces`);
export const getCity = (params) => api('post', `/Setting/Cities`, params);
export const getSettings = (params) => api('get', `/Setting/Get`, params);

// Card
export const getMyCard = () => api('get', `/Card/UserCards`);
export const buyCard = (params) => api('post', `/Card/Buy`, params);
export const fastCharge = (params) => api('post', `/Card/FastCharge`, params);
export const BuyConfirm = (params) => api('post', `/Card/BuyConfirm`, params);
export const UpdateCard = (params) => api('post', `/Card/Update`, params);

// Basket
export const addToBasket = (params) => api('post', `/Basket`, params);
export const deleteFromBasket = (params) => api('post', `/Basket/Delete`, params);
export const setCountBasketList = (params) => api('post', `/Basket/SetCount`, params);
export const getBasketList = (params)=> api('get', `/Basket/${params}`); 